module.exports = __webpack_public_path__ + "media/images/header_icons/notification-06882c3ebb826a9473e56c5420c1e2ba.svg";